import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import styles from "./videoscreen.module.scss";
import store from '../../store/redux-store/root_store';
import _ from 'lodash';
import { initialStateModel, ParticipantDetails } from '../../base/models/meetModal';
import { VirtualBGRender } from './virtualBGRrender';
import { PostProcessingConfig } from '../virtualBackground/core/helpers/postProcessingHelper';
import { BackgroundConfig } from '../virtualBackground/core/helpers/backgroundHelper';
import { SegmentationConfig } from '../virtualBackground/core/helpers/segmentationHelper';
import { VirtualBGModel } from '../virtualBackground/core/helpers/VBModel';
import { useSelector } from 'react-redux';
type VideoShareLeftBarProps = {
  elem: any;
  type:any;
};

export default function VideoShareLeftBar( {elem,type}:VideoShareLeftBarProps) {
  const { activeParticipantList, currdeviceinfo,vmSettings } = store.getState().meetingReducer;
  const videoMeetState: initialStateModel = useSelector((state: initialStateModel) => state);
  let stored_Video = store.getState().storeVideo;
  let participantVideo: any = useRef(null);

  const canvasEL: any = document.getElementById('canvas123');
  const gl = canvasEL.getContext('webgl2') || null;
  const getRes = new VirtualBGModel(gl ? 'mlkit' : 'bodyPix', true, "webgl");

  const [
    segmentationConfig,
    setSegmentationConfig
  ] = useState<SegmentationConfig>(getRes.getResolutionDetails());

  const [
    postProcessingConfig,
    setPostProcessingConfig
  ] = useState<PostProcessingConfig>({
    smoothSegmentationMask: false,
    jointBilateralFilter: { sigmaSpace: 5.6, sigmaColor: 0.3 },
    coverage: [0.5, 0.75],
    lightWrapping: 0.1,
    blendMode: 'screen'
  });
  const backgroundConfig: BackgroundConfig =
    { "type": "image", "url": (!_.isEmpty(vmSettings) && vmSettings?.isVirtualBackground !==0 && vmSettings?.virtualBackground!== null && vmSettings?.virtualBackgroundId !== null) ?  vmSettings?.virtualBackground : ""};
    let playbackInfo:any="";
  if(participantVideo.current){
      playbackInfo = {
        htmlElement: participantVideo.current,
        width: participantVideo.current?.videoWidth,
        height: participantVideo.current?.videoHeight
      };
    
    }
  const videoRender = () => {
    try {
      let userInfo: ParticipantDetails = elem || [];
      if (userInfo.status === "joined") {
        let videoData: any = _.find(stored_Video.participantList, { participants: userInfo.conId });
        if (videoData !== undefined && videoData.stream !== '') {
            if ((participantVideo.current.srcObject === null)
              || (participantVideo.current.srcObject.id !== videoData.stream.id)) {
              participantVideo.current.srcObject = videoData.stream;
              if (userInfo.conId === currdeviceinfo.conId) {
                participantVideo.current.muted = true;
              }
            }
          
        }
      }
    }
    catch (e: any) { console.log("error", e); }
  };
  
  useEffect(()=>{
    videoRender();
  },[ activeParticipantList, stored_Video,stored_Video.participantList.length, activeParticipantList.length,videoMeetState.VirtualBG.peerConCheck])

  return (
    <>

        <div className={styles.videoshareinner}>
          <div className={styles.videosharebox}>

            <div className={styles.videshareaudio}>

            {!elem?.mute ?
                    
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="20" height="20" rx="4.49444" fill="black" fill-opacity="0.2"/>
                    <g clip-path="url(#clip0_3287_79419)">
                    <path d="M9.99981 12.177C11.143 12.177 12.0734 11.2466 12.0734 10.1034V5.72317C12.0734 4.57997 11.1431 3.6499 9.99981 3.6499C8.85654 3.6499 7.92654 4.5799 7.92654 5.72317V10.1034C7.92654 11.2466 8.85654 12.177 9.99981 12.177ZM8.92654 5.72317C8.92654 5.13137 9.40801 4.6499 9.99981 4.6499C10.5919 4.6499 11.0734 5.13137 11.0734 5.72317V10.1034C11.0734 10.6955 10.5919 11.177 9.99981 11.177C9.40801 11.177 8.92654 10.6955 8.92654 10.1034V5.72317Z" fill="#000"/>
                    <path d="M14.2934 10.0366V8.02977C14.2934 7.7537 14.0695 7.52977 13.7934 7.52977C13.5173 7.52977 13.2934 7.7537 13.2934 8.02977V10.0366C13.2934 11.7752 11.8162 13.19 9.99981 13.19C8.18341 13.19 6.70654 11.7752 6.70654 10.0366V8.02977C6.70654 7.7537 6.48261 7.52977 6.20654 7.52977C5.93048 7.52977 5.70654 7.7537 5.70654 8.02977V10.0366C5.70654 12.1628 7.36768 13.9186 9.49981 14.1593V15.4829H7.21988C6.98061 15.4829 6.78661 15.6769 6.78661 15.9165C6.78661 16.1561 6.98061 16.3501 7.21988 16.3501H12.7797C13.0193 16.3501 13.2133 16.1561 13.2133 15.9165C13.2133 15.6769 13.0193 15.4829 12.7797 15.4829H10.4998V14.1593C12.632 13.9186 14.2934 12.1628 14.2934 10.0366Z" fill="#000"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_3287_79419">
                    <rect width="16" height="16" fill="white" transform="translate(2 2)"/>
                    </clipPath>
                    </defs>
                    </svg>
                     : 
                                    
                    
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="20" height="20" rx="4.49444" fill="black" fill-opacity="0.2"/>
                    <g clip-path="url(#clip0_3287_79412)">
                    <path d="M8.92669 7.31002L11.0734 9.46336L11.5734 9.97002L12.0467 10.4434C12.0667 10.33 12.0734 10.2167 12.0734 10.1034V5.72336C12.0734 4.57669 11.14 3.65002 10 3.65002C8.85336 3.65002 7.92669 4.57669 7.92669 5.72336V6.30336L8.42669 6.80336L8.92669 7.31002Z" fill="#DE003D"/>
                    <path d="M14.2934 10.0367V8.03002C14.2934 7.75002 14.0667 7.53002 13.7934 7.53002C13.52 7.53002 13.2934 7.75002 13.2934 8.03002V10.0367C13.2934 10.5167 13.18 10.97 12.9734 11.3767L13.7067 12.1167C14.08 11.5034 14.2934 10.7967 14.2934 10.0367Z" fill="#DE003D"/>
                    <path d="M15.7867 15.85C15.6867 15.95 15.56 15.9967 15.4334 15.9967C15.3067 15.9967 15.18 15.95 15.08 15.85L12.58 13.3434C11.9867 13.7834 11.28 14.0767 10.5 14.1634V15.4834H12.7867C13.0267 15.4834 13.22 15.6767 13.22 15.9167C13.22 16.1567 13.0267 16.35 12.7867 16.35H7.22003C6.98003 16.35 6.78669 16.1567 6.78669 15.9167C6.78669 15.6767 6.98003 15.4834 7.22003 15.4834H9.50003V14.1634C7.36003 13.9234 5.70003 12.1634 5.70003 10.0367V8.03002C5.70003 7.75002 5.92669 7.53002 6.20003 7.53002C6.47336 7.53002 6.70003 7.75002 6.70003 8.03002V10.0367C6.70003 11.7767 8.18003 13.19 10 13.19C10.6934 13.19 11.34 12.9834 11.8734 12.63L11.1 11.85C10.78 12.0567 10.4067 12.17 10 12.17C8.85336 12.17 7.92669 11.2434 7.92669 10.1034V8.66336L4.21336 4.93669C4.02003 4.74336 4.02003 4.42336 4.21336 4.23002C4.40669 4.03669 4.72669 4.03669 4.92003 4.23002L15.7867 15.1434C15.98 15.3367 15.98 15.6567 15.7867 15.85Z" fill="#DE003D"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_3287_79412">
                    <rect width="16" height="16" fill="white" transform="translate(2 2)"/>
                    </clipPath>
                    </defs>
                    </svg>
}

              {/* <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.98877" y="-0.0078125" width="20" height="20" rx="6" fill="black" fill-opacity="0.2" />
                <g clip-path="url(#clip0_2789_64865)">
                  <path d="M10.9889 5.87695C10.7128 5.87695 10.4889 6.10075 10.4889 6.37695V13.6066C10.4889 13.8827 10.7128 14.1066 10.9889 14.1066C11.265 14.1066 11.4889 13.8827 11.4889 13.6066V6.37695C11.4889 6.10075 11.265 5.87695 10.9889 5.87695Z" fill="#575CFF" />
                  <path d="M15.7258 8.57142C15.4497 8.57142 15.2258 8.79522 15.2258 9.07142V10.9121C15.2258 11.1882 15.4497 11.4121 15.7258 11.4121C16.002 11.4121 16.2258 11.1882 16.2258 10.9121V9.07142C16.2258 8.79522 16.002 8.57142 15.7258 8.57142Z" fill="#575CFF" />
                  <path d="M6.25195 8.57142C5.97582 8.57142 5.75195 8.79522 5.75195 9.07142V10.9121C5.75195 11.1882 5.97582 11.4121 6.25195 11.4121C6.52809 11.4121 6.75195 11.1882 6.75195 10.9121V9.07142C6.75195 8.79522 6.52809 8.57142 6.25195 8.57142Z" fill="#575CFF" />
                  <path d="M13.3574 7.43342C13.0812 7.43342 12.8574 7.65722 12.8574 7.93342V12.0503C12.8574 12.3264 13.0812 12.5503 13.3574 12.5503C13.6335 12.5503 13.8574 12.3264 13.8574 12.0503V7.93342C13.8574 7.65722 13.6335 7.43342 13.3574 7.43342Z" fill="#575CFF" />
                  <path d="M8.62042 7.43342C8.34429 7.43342 8.12042 7.65722 8.12042 7.93342V12.0503C8.12042 12.3264 8.34429 12.5503 8.62042 12.5503C8.89655 12.5503 9.12042 12.3264 9.12042 12.0503V7.93342C9.12042 7.65722 8.89655 7.43342 8.62042 7.43342Z" fill="#575CFF" />
                </g>
                <defs>
                  <clipPath id="clip0_2789_64865">
                    <rect x="2.98877" y="1.99219" width="16" height="16" rx="6" fill="white" />
                  </clipPath>
                </defs>
              </svg> */}

            </div>
             {!elem?.video && (
             <div className='novideoname forcustomer sharescreen'>
                <div className="novideonametext">{elem?.name?.toUpperCase().slice(0, 2)}</div>
             </div>
            )}
         {currdeviceinfo && currdeviceinfo.conId === elem.conId && type ==="agent" &&
          participantVideo.current && videoMeetState.VirtualBG.peerConCheck &&
          backgroundConfig &&
          playbackInfo.htmlElement &&
          playbackInfo.width &&
          videoMeetState.VirtualBG.tflite &&
          videoMeetState.VirtualBG.bodyPix &&
          postProcessingConfig &&
          segmentationConfig &&
          videoMeetState.VirtualBG.image &&
          currdeviceinfo.video ? (
            <VirtualBGRender
              imgIndex={videoMeetState.VirtualBG.imgIndex}
              sourcePlayBack={playbackInfo}
              backgroundConfig={backgroundConfig}
              segmentationConfig={segmentationConfig}
              tflite={videoMeetState.VirtualBG.tflite}
              bodyPix={videoMeetState.VirtualBG.bodyPix}
              postProcessingConfig={postProcessingConfig}
              participant={currdeviceinfo}
              innerStyles={{
                position: "absolute",
                left: "0",
                width: "100%",
                zIndex: 0,
                top: "0px",
                height: "100%",
                transform:"none",
                borderRadius:"10px"
              }}
            ></VirtualBGRender>
          ) : null}
            <video
                    playsInline
                    autoPlay
                    ref={participantVideo}
                    id={elem.conId}
                    preload={"auto"}
                    style={{ display: elem?.video ? "block" : "none" }}
                    muted={true}
                />

            <h4 className={styles.username}>{elem.conId === currdeviceinfo.conId ? "You" : elem.name}</h4>
          </div>
        </div>



    </>
  );

};
